<script setup lang="tsx">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { RiskMeta } from '@/models/api-generated'
import { formatDate, getTreatmentText } from '@/services/utils'
import { formatRiskScoreStr } from '../shared'

const model = defineModel<RiskMeta>({ required: true })
const { t } = useI18n()

const expanded = ref(false)

const visibleDecisions = computed(() => (expanded.value ? model.value.decisions : model.value.decisions.slice(0, 2)))

const showFade = computed(() => !expanded.value && model.value.decisions.length > 2)
</script>

<template>
	<div class="flex-grow-1">
		<div class="mb-2 d-flex justify-content-between align-items-center">
			<span class="fw-bold">{{ t('risk.riskDecision', 2) }}</span>

			<button v-if="model.decisions.length > 2" class="btn btn-sm btn-outline-secondary" @click="expanded = !expanded">
				<i :class="expanded ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
			</button>
		</div>

		<div class="decisions-wrapper">
			<table class="table table-sm mt-2 mb-0">
				<thead>
					<tr>
						<th>{{ t('risk.user') }}</th>
						<th>{{ t('risk.residual') }}</th>
						<th>{{ t('risk.decision') }}</th>
						<th>{{ t('risk.date') }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in visibleDecisions" :key="item.createdAt">
						<td>{{ item.user.label }}</td>
						<td>{{ formatRiskScoreStr(item.residual) }}</td>
						<td>{{ getTreatmentText(item.treatment) }}</td>
						<td>{{ formatDate(item.createdAt) }}</td>
					</tr>
				</tbody>
			</table>

			<div v-if="showFade" class="decisions-fade"></div>
		</div>
	</div>
</template>

<style lang="sass" scoped>
.decisions-wrapper
	position: relative

.decisions-fade
	position: absolute
	left: 0
	bottom: 0
	width: 100%
	height: 2.5rem
	pointer-events: none
	background: linear-gradient(to bottom, rgba(255,255,255,0), var(--bs-body-bg))
</style>
